module.exports = __webpack_public_path__ + "static/media/img_login.18cb987d.webp";